const { GET_TRANSLATION, GET_TRANSLATIONS_ERROR } = require('../actions/types');

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_TRANSLATION:
      return {
        ...state,
        data: payload,
        loading: false,
        error: null,
      };
    case GET_TRANSLATIONS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
